"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarVariant = void 0;
/**
 * Variant of snackbar.
 */
var SnackbarVariant;
(function (SnackbarVariant) {
    SnackbarVariant["SUCCESS"] = "success";
    SnackbarVariant["WARNING"] = "warning";
    SnackbarVariant["ERROR"] = "error";
    SnackbarVariant["INFO"] = "info";
    SnackbarVariant["BLANK"] = "blank";
})(SnackbarVariant = exports.SnackbarVariant || (exports.SnackbarVariant = {}));
//# sourceMappingURL=snackbar-types.js.map